import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="hide-when-only-one"
export default class extends Controller {

	static targets = [ 'element' ]

	static values = { selector: String }

	elementTargetConnected(_element)    { this.updateElements() }
	elementTargetDisconnected(_element) { this.updateElements() }

	updateElements() {
		let elements = []
		if (this.hasSelectorValue) {
			elements = this.element.querySelectorAll(this.selectorValue)
		} else {
			elements = this.elementTargets
		}

		if (!elements || elements.length == 0) { return }
		if (elements.length == 1) { elements[0].classList.add('d-none') }
		if (elements.length  > 1) { elements.forEach( (element) => element.classList.remove('d-none') ) }
	}
}
